import React from 'react'
import FaqHead from '../../../HomePage/Faq/FaqHead'
import DegreeCertAttestationFaqMain from './DegreeCertAttestationFaqMain'

const DegreeCertAttestationFaq = () => {
  return (
 <div className="faqContainer">
      <div className="faqContent">
        <FaqHead heading="Degree Certificate Attestation in Bangalore" />
        <DegreeCertAttestationFaqMain />
      </div>
    </div>
  )
}

export default DegreeCertAttestationFaq
